import React from 'react'
import styled from 'styled-components'

const Title = styled.h3`
  font-family: ${(props) => props.theme.font.family.secondary};
  font-size: ${(props) => props.theme.font.size['20']};
  line-height: 30px;
  margin-bottom: 24px;
  font-weight: 700;
  color: ${(props) => props.theme.color.text.lightDark};

  @media (max-width: 991px) {
    font-size: ${(props) => props.theme.font.size['16']};
    margin-bottom: 16px;
  }
`

interface SubTitleProps {
  children: any
}

function SubTitle({ children }: SubTitleProps) {
  return <Title>{children}</Title>
}

export default SubTitle
